import { StructError } from 'superstruct';
import { call } from '../../../../stent/call';
import { ItemsAddedToCart } from '../../context/add-items-to-cart/response';
import { Cart } from '../../../schema';
const animateCartIcon = (originalTotalPrice)=>{
    if (typeof window === 'undefined') {
        return;
    }
    const _cartRect = document.querySelector('.shopcartrect');
    const cartRect = _cartRect instanceof HTMLElement ? _cartRect : null;
    const _cartSqueezed = document.querySelector('.shopcartsqueezed');
    const cartSqueezed = _cartSqueezed instanceof HTMLElement ? _cartSqueezed : null;
    const _cartRectMobile = document.querySelector('.shopcartrectMobile');
    const cartRectMobile = _cartRectMobile instanceof HTMLElement ? _cartRectMobile : null;
    const _cartSqueezedMobile = document.querySelector('.shopcartsqueezedMobile');
    const cartSqueezedMobile = _cartSqueezedMobile instanceof HTMLElement ? _cartSqueezedMobile : null;
    if (cartRect == null || cartRectMobile == null || cartSqueezed == null || cartSqueezedMobile == null) {
        console.error('Cart icon elements not found [b206343f09a449448b6de627e93d749f]');
        return;
    }
    cartRect.style.opacity = '0';
    cartRectMobile.style.opacity = '0';
    cartSqueezed.style.opacity = '1';
    cartSqueezedMobile.style.opacity = '1';
    if (originalTotalPrice === 0) {
        document.querySelectorAll('animate').forEach((element)=>{
            element.beginElement();
        });
    }
    setTimeout(()=>{
        cartRect.style.opacity = '1';
        cartRectMobile.style.opacity = '1';
        cartRect.setAttribute('fill', 'url(#blue-two)');
        cartRectMobile.setAttribute('fill', 'url(#blue-twoMobile)');
        cartSqueezed.style.opacity = '0';
        cartSqueezedMobile.style.opacity = '0';
    }, 150);
};
export const makeAddItems = function(ctx) {
    const { addItemsToCart , fetchCartContents , afterUpdate  } = ctx;
    return function* addItems(machine, payload) {
        try {
            const { input , resolve , reject  } = payload;
            if (machine.state.contents == null) {
                throw new Error('Cart contents missing');
            }
            yield {
                name: 'AddingItems',
                error: null,
                contents: machine.state.contents
            };
            try {
                // TODO Side-effects should be part of the context
                animateCartIcon(machine.state.contents.original_total_price);
                const rawAddItemsResponse = yield call(addItemsToCart, input);
                const [err, data] = ItemsAddedToCart.validate(rawAddItemsResponse, {
                    coerce: true
                });
                if (err instanceof StructError) {
                    console.error('Add To Cart response can not be parsed', err.failures(), data);
                }
                afterUpdate === null || afterUpdate === void 0 ? void 0 : afterUpdate();
                resolve(err ? null : data == null ? null : data);
            } catch (err) {
                reject(err instanceof Error ? err : new Error('Unknown error [819a802f80b140d4803315f361ad094b]'));
            }
            const rawFetchCartResponse = yield call(fetchCartContents, undefined);
            const [err, contents] = Cart.validate(rawFetchCartResponse, {
                coerce: true
            });
            if (err instanceof StructError) {
                console.error('Cart data can not be parsed', err.failures(), contents);
                throw err;
            }
            if (!contents) {
                console.error('Cart data is invalid', contents);
                throw new Error('Cart data is invalid');
            }
            yield {
                contents,
                name: 'Stale',
                error: null
            };
            machine.refresh();
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [f84a567a4b1a4ed093eb219f43e3a6df]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
